<div class="view-mode-toggle">
  <button
    mat-icon-button
    [class.active]="viewMode === 'grid'"
    (click)="onToggle('grid')"
    matTooltip="{{ 'documentBrowser.viewMode.grid' | translate }}"
  >
    <i class="das das-grid-view fs-4"></i>
  </button>
  <button
    mat-icon-button
    [class.active]="viewMode === 'list'"
    (click)="onToggle('list')"
    matTooltip="{{ 'documentBrowser.viewMode.list' | translate }}"
  >
    <i class="das das-list-view fs-4"></i>
  </button>
</div>
